// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={24} height={24} />;

// https://akveo.github.io/eva-icons
// https://icones.js.org/collection/eos-icons

const navConfig = [
  {
    title: 'nav.dashboard',
    path: '/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'nav.profile',
    path: '/profile',
    icon: getIcon('material-symbols:perm-data-setting'),  // eva:attach-fill
  },
  {
    title: 'nav.admin',
    path: '/admin',
    icon: getIcon('eos-icons:admin'),
  },
  {
    title: 'nav.users',
    path: '/user',
    icon: getIcon('eva:people-fill'),
  },
  {
    title: 'nav.enroll',
    path: '/register',
    icon: getIcon('fluent:people-add-20-filled'),  // eva:person-add-fill
  },
  {
    title: 'nav.contact',
    path: '/admin/contact',
    icon: getIcon('eva:book-open-fill'),
  },
  // {
  //   title: 'notifications',
  //   path: '/push-notification',
  //   icon: getIcon('eva:message-circle-fill'),
  // },
  // {
  //   title: 'messages',
  //   path: '/chatroom',
  //   icon: getIcon('eva:message-circle-fill'),
  // },
];

export default navConfig;
